import React, { useEffect, useState } from 'react';
import style from './Gameboard.scss.json';
import './Gameboard.scss';
import { useTranslate } from '@tolgee/react';
import { InteractiveGlobe } from '../atoms/InteractiveGlobe';
import { LocationTotals } from 'lincd-irlcg/lib/types/gameboard';

export const Gameboard = ({
  totalScore,
  totalLocation,
}: {
  totalScore?;
  totalLocation: LocationTotals;
}) => {
  const { totalActions, totalPlayer } = totalScore;
  let { t } = useTranslate();

  return (
    <div className={style.titleContainer}>
      <h1>{t('word.GlobalGameBoard', 'Peace Gameboard')}</h1>
      <div className={style.interactiveGlobe}>
        <InteractiveGlobe />
      </div>
      <div className={style.statusContainer}>
        <div className={style.status}>
          <h2 className={style.title}>{totalPlayer || 0}</h2>
          <p>{t('word.Players', 'Players')}</p>
        </div>
        <div className={style.status}>
          <h2 className={style.title}>{totalActions || 0}</h2>
          <p>{t('word.peaceActions', 'Peace Actions')}</p>
        </div>
        <div className={style.status}>
          {/* <h2 className={style.title}>{totalLocation?.city || 0}</h2> */}
          <h2 className={style.title}>608</h2>
          <p>{t('word.cities', 'Cities')}</p>
        </div>
        <div className={style.status}>
          {/* <h2 className={style.title}>{totalLocation?.country || 0}</h2> */}
          <h2 className={style.title}>67</h2>
          <p>{t('word.countries', 'Countries')}</p>
        </div>
      </div>
    </div>
  );
};
